import gql from 'graphql-tag';

import { IntrospectionFragmentMatcher } from 'apollo-cache-inmemory';

export const contentNewsFragment = gql`
  fragment ContentNewsFragment on NewsContent {
    id
    title
    title_de
    title_en
    title_fr
    title_nl
    title_no
    title_et
    title_el
    title_hu
    title_es
    title_sv
    title_pt
    title_lb
    title_da
    title_pl
    title_al
    title_ca
    title_eu
    title_gl
    subtitle
    subtitle_de
    subtitle_en
    subtitle_fr
    subtitle_nl
    subtitle_no
    subtitle_et
    subtitle_el
    subtitle_hu
    subtitle_es
    subtitle_sv
    subtitle_pt
    subtitle_lb
    subtitle_da
    subtitle_pl
    subtitle_al
    subtitle_ca
    subtitle_eu
    subtitle_gl
    banner
    link
    link_de
    link_en
    link_fr
    link_nl
    link_no
    link_et
    link_el
    link_hu
    link_es
    link_sv
    link_pt
    link_lb
    link_da
    link_pl
    link_al
    link_ca
    link_eu
    link_gl
    published
    geohash
    radius_meter
    country_code
    country_codes
    only_new_users
    only_never_used_delivery_token_users
    only_used_brands
    only_used_stores
    only_for_store_types
    only_for_non_usage_fee_enabled
    only_for_languages
    for_consumers
    for_partners
    type
    score
    city_id
    hide_from
  }
`;

export const adminCampaignFragment = gql`
  fragment AdminCampaignFragment on Campaign {
    id
    brand_id
    store_id
    product {
      id
      name
    }
    product_id
    brand_name
    store_street
    store_name
    single_use_only
    new_customers_only
    price
    offer_name
    offer_partner_label
    quantity_max
    promotion_code
    type
    discount_type
    active_hours {
      day
      time
    }
    start_date
    end_date
    teaser_image_start
    teaser_image_detail
    is_featured
    terms
    discount_percent
    discount_amount
    user_quantity
    code_single_use
    show_success
    referral_name
    payed_by_partner_share
    min_order_value
    block_activation_from
    allow_unverified
    used_at
    original_permanent_campaign {
      id
      offer_name
    }
  }
`;

export const userFragment = gql`
  fragment UserFragment on User {
    id
    name
    given_name
    family_name
    fraud_check
    email
    # email_verified
    nickname
    role
    phone_number
    # phone_number_verified
    # used_brand_ids
    # favorite_stores
    active_campaigns {
      id
      quantity_max
      promotion_code
      start_date
      end_date
      terms
      discount_percent
      user_quantity
      offer_name
      referral_name
    }
    unlocked_achievements {
      id
      unlocked_at
    }
    # payment_details {
    #   paypal_id
    #   stripe_id
    #   default_source {
    #     id
    #     brand
    #     last4
    #     object
    #     fingerprint
    #     name
    #     type
    #   }
    #   sources {
    #     id
    #     brand
    #     last4
    #     object
    #     fingerprint
    #     name
    #     type
    #   }
    # }
    # accepted_agb
    # accept_agb
    # accept_privacy
    # accept_push
    # push_id
    # accept_newsletter
    # picture
    # referral_code
    # success_campaign {
    #   id
    #   offer_name
    #   referral_name
    #   show_success
    # }
  }
`;

export const categoryFragment = gql`
  fragment CategoryFragment on Category {
    id
    name
    icon
    icon_cyan
    published
    reusable_packaging
    placeholder
    products {
      ...ProductFragment
    }
  }
`;

export const variantProductFragment = gql`
  fragment VariantProductFragment on Product {
    id
    name
    price
    has_cutlery
    old_price
    is_promo
    has_inherited_extras
    published
    reusable_packaging
    image
    teaser_text
    teaser_text_long
    vat_rate
    preferred_height
    allergens
    title
  }
`;

export const productFragment = gql`
  fragment ProductFragment on Product {
    id
    name
    price
    has_cutlery
    old_price
    is_promo
    image
    has_inherited_extras
    published
    reusable_packaging
    placeholder
    teaser_text
    teaser_text_long
    vat_rate
    # preferred_height
    allergens
    # specialities {
    #   food_type
    #   is_halal
    #   is_kosher
    # }
    # brand {
    #   id
    #   name
    #   short_name
    #   address
    #   contact
    #   logo
    #   allergens_info
    #   allergens_info_url
    # }
    category {
      id
      name
      icon
      placeholder
      published
      reusable_packaging
    }
    variants {
      variant_id
      name
      title
      price
      old_price
      is_promo
      has_inherited_extras
      allergens
      image
      is_default
      extra_groups {
        name
        extra_group_id
        # has_inputfield
        is_open
        default_extras
        minimum_extras
        maximum_extras
        items {
          extra_id
          group_id
          name
          price
          price_raw
          # specialities {
          #   food_type
          #   is_kosher
          #   is_halal
          # }
          allergens
          is_selected
        }
      }
      vat_rate
      teaser_text
    }
    extra_groups {
      name
      extra_group_id
      # has_inputfield
      is_open
      default_extras
      minimum_extras
      maximum_extras
      items {
        extra_id
        group_id
        name
        price
        price_raw
        # specialities {
        #   food_type
        #   is_kosher
        #   is_halal
        # }
        allergens
        is_selected
      }
    }
  }
`;

export const brandAdminFragment = gql`
  fragment BrandAdminFragment on Brand {
    id
    name
    short_name
    permanently_removed
    # address
    logo
    address2 {
      streetname
      streetno
      street_extra
      zip
      city
    }
    prefix
    legal_name
    invoice_email
    stores {
      currency
    }
    external_salesforce_id
    external_vytal_id
    # some only for admins
    monthly_fee
    onboarding_fee_vytal
    separate_invoice_each_store
    commission_rate
    commission_rate_reduced
    regular_payment_target_days
    dunning_reminder_block_type
    dunning_reminder_block_reason
    dunning_reminder_block_until
    is_dunning_reminder_stopped
    change_history {
      old_values
      new_values
      changed_at
      changed_by
      changed_by_raw
    }
  }
`;

export const StripeSourceFragment = gql`
  fragment StripeSourceFragment on StripeSource {
    id
    object
    fingerprint
    brand
    last4
    name
    email
    type
  }
`;

export const storeFragmentWithCategories = gql`
  fragment StoreFragmentWithCategories on Store {
    id
    # geo_hash
    banner
    # eat_in_option
    online
    published
    name
    # phone_number
    # website
    # description
    location_name
    # route_help
    # pickup_route_help
    # poi_location
    # product_tags
    # pickup_point {
    #   image
    #   max_height
    #   scale
    # }
    min_order_time # in seconds
    cancelation_time # in seconds
    # labels {
    #   text
    #   color
    # }
    # floor_plan
    # heartbeat
    # pickie
    block_campaigns
    opening_hours {
      day
      time
    }
    # address {
    #   city
    #   streetname
    #   streetno
    #   zip
    # }
    categories {
      id
      name
    }
    brand {
      id
      name
      short_name
      # address
      logo
    }
    external_vytal_id
    service_package_type
    onboarding_status
    country_code
    type
  }
`;
export const storeFragment = gql`
  fragment StoreFragment on Store {
    id
    # geo_hash
    banner
    # eat_in_option
    online
    published
    name
    # phone_number
    # website
    # description
    location_name
    # route_help
    # pickup_route_help
    # poi_location
    # product_tags
    # pickup_point {
    #   image
    #   max_height
    #   scale
    # }
    min_order_time # in seconds
    cancelation_time # in seconds
    # labels {
    #   text
    #   color
    # }
    # floor_plan
    # heartbeat
    # pickie
    block_campaigns
    opening_hours {
      day
      time
    }
    # address {
    #   city
    #   streetname
    #   streetno
    #   zip
    # }
    brand {
      id
      name
      short_name
      # address
      logo
    }
    images {
      created_at
      source
      url
      origin_url
      original_url
    }
    menu_link
    last_google_opening_hours_sync
    coming_soon
  }
`;
export const storeAdminFragment = gql`
  fragment StoreAdminFragment on Store {
    invoice_routing_id
    order_number
    seller_id
    service_package_type
    service_package_start_date
    free_checkout_segment
    external_id
    invoice_yearly
    needs_purchasing_order_number
    purchasing_order_email
    yearly_renewal_fee
    id
    geo_hash
    eat_in_option
    online
    published
    can_preorder
    can_deliver
    always_online
    show_in_stats
    coming_soon
    permanently_removed
    name
    phone_number
    website
    description
    location_name
    region
    type
    available_soon
    available_from
    has_wolt
    lieferando_url
    wolt_url
    habgusta_url
    mjam_url
    labonapp_url
    ubereats_url
    split_app_url
    too_good_to_go_url
    rappi_url
    didi_food_url
    foodora_url
    google_places_id
    lonlat {
      longitude
      latitude
    }

    linked_city {
      id
      name
      store_count
    }

    food_info_de
    food_info_en
    description_de
    description_en
    description_fr
    description_nl
    description_no
    description_et
    description_el
    description_es
    description_sv
    description_pt
    description_lb
    description_da
    description_pl
    description_hu
    description_al
    description_ca
    description_eu
    description_gl
    contracted_date
    contract_end_date
    onboarded_date
    test_period_end
    temporary_access_from
    termination_reason
    termination_comment
    menu_link
    accepted_container_type_group_ids
    preferred_locale

    invoice_headline

    # route_help
    # pickup_route_help
    # poi_location
    # product_tags
    # pickup_point {
    #   image
    #   max_height
    #   scale
    # }
    min_order_time # in seconds
    cancelation_time # in seconds
    labels {
      text
      color
      text_color
    }
    # floor_plan
    # heartbeat
    # pickie
    block_campaigns
    opening_hours_multi_raw {
      day
      time
    }
    special_opening_hours_multi {
      day
      time
    }
    delivery_hours_raw {
      day
      time
    }
    special_delivery_hours {
      day
      time
    }
    preorder_hours_raw {
      day
      time
    }
    address {
      city
      state
      streetname
      streetno
      street_extra
      zip
    }
    delivery_address {
      company
      first_name
      last_name
      streetname
      streetno
      zip
      city
      additional_info
      email
      phone_number
      country
    }
    brand {
      id
      name
      short_name
      # address
      logo
    }
    phone_from_vytal
    sim_info
    sim_phone_number
    sim_payment_automation
    offline_card_cost
    custom_invoice_items {
      type
      total
      title
      description
      billing_frequency
      billing_start_with_onboarding
      billing_start
    }
    invoice_email
    invoice_address {
      streetname
      streetno
      street_extra
      zip
      city
      country
    }
    legal_name
    onboarding_fee_vytal
    acquired_by
    acquired_at
    min_order_time
    cancelation_time
    debitor_account_number
    preorder_sms_number
    images {
      created_at
      source
      url
      origin_url
      original_url
    }

    internal_comment
    min_delivery_order_value
    min_delivery_time
    delivery_fee
    type

    phones {
      id
      type
      sim_provided
      sim_card_number
      phone_number
      monthly_charge
      pin
      serial_number
      description
      billing_frequency
      billing_start_with_onboarding
      billing_start
    }

    return_boxes {
      id
      type
      location
      monthly_charge
      serviced
      billing_frequency
      billing_start_with_onboarding
      billing_start
      publish_return_box_in_app
    }
    has_return_box_published_in_app

    invoice_email_subject_prefix
    invoice_iban_name
    invoice_iban
    partner_newsletter_email
    country_code
    created_by
    food_categories
    currency

    partner_credits
    partner_credits_usable_until

    store_wide_discount_percent

    minimum_monthly_transaction_charge
    monthly_service_fee
    monthly_flat_fee
    use_circulation_based_billing
    offline_timeout
    google_places_id
    manual_overwrite_store_info
    disable_automatic_partner_invoice_sending
    disable_automatic_partner_charging
    external_salesforce_id
    external_zoho_crm_id
    charge_onboarding_fee
    external_vytal_id
    vending_machines {
      id
      name
    }
    store_layout
    store_layout_vending_machines_json
    tier
    revenue_tier
    feature_container_collection_enabled
    allow_inventory_checks_for_terminal_users
    allow_inventory_checks_for_terminal_users_until
    allow_inventory_checks_for_terminal_users_permanently
    additional_allowance
    additional_allowance_valid_until
    container_groups {
      id
      id_int
      image_urls
      name
      can_edit
      admin_only
      order_key
    }
    last_google_opening_hours_sync
    charge_non_usage_fee
    non_usage_fee_enabled
    is_net_receiver
    dpd_pickup_compulsory
    possible_merchant_order_types
    vat_number
    permanently_closed
    employee_only
    send_nuf_info_to_invoice_address
    nuf_comment
    excluded_from_nuf_until
    order_preferences {
      allow_koziol
      allow_mepal
    }
    mini_returners {
      id
      monthly_charge
      billing_start
      billing_start_with_onboarding
    }
    tap2borrow_devices {
      id
      type
      serial_number
      monthly_charge
      billing_start
      billing_start_with_onboarding
      hide_on_invoice
    }
    can_order_secondary_portfolio
    default_inventory_check_expiration_days
    new_inventory_checks_are_non_billable
    sustainability_reports_enabled
    regular_payment_target_days
    sepa_2_percent_discount
    dunning_reminder_block_type
    dunning_reminder_block_reason
    dunning_reminder_block_until
    inkassokennzeichen
    invoicing_disabled_permanently
    invoicing_disabled_until
    is_invoicing_currently_disabled
    onboarding_status
    integrations
    credit_to_partner
    default_carriers {
      carrier_service
      carrier
    }
    effective_default_carriers {
      carrier_service
      carrier
    }
    available_carrier_services {
      carrier
      services
    }
  }
`;

export const storeDeliveryAdminFragment = gql`
  fragment StoreDeliveryAdminFragment on Store {
    id
    name
    can_deliver
    delivery_area
    sd_application_key
    sd_store_id
  }
`;

export const storeCardFragment = gql`
  fragment StoreCardFragment on Store {
    id
    # geo_hash
    banner
    online
    # published
    name
    location_name
    product_tags
    opening_hours {
      day
      time
    }
    brand {
      id
      logo
      name
    }
    labels {
      text
      color
    }
  }
`;

export const campaignFragment = gql`
  fragment CampaignFragment on Campaign {
    id
    price
    offer_name
    promotion_code
    discount_percent
    referral_name
    terms
  }
`;

export const orderFragment = gql`
  fragment OrderFragment on Order {
    id
    transaction_id
    code_text
    readable_id
    created_at
    pickup_time
    pickedup_time
    type
    item_count
    platform_fee
    transaction_id
    payment_method
    status
    total
    store_total
    terminal_total
    cutlery
    eat_in
    store {
      ...StoreFragment
    }
    items {
      id
      name
      price
      base_price
      quantity
      product_id
      variant_id
      store_id
      charged_price_total
      tags
      image
      in_stock
      stock_quantity
      extras {
        extra_id
        name
        group_name
        price
        in_stock
      }
    }
    vat_total {
      vat_rate
      vat_amount
    }
    campaign {
      ...CampaignFragment
    }
  }
  ${storeFragment}
  ${campaignFragment}
`;

export const locationFragment = gql`
  fragment LocationFragment on Location {
    id
    name
    tags
    label
    floor_plan
    lonlat {
      longitude
      latitude
    }
    address {
      city
      streetname
      streetno
      zip
    }
  }
`;

export const vendingMachineFragment = gql`
  fragment VendingMachineFragment on VendingMachine {
    id
    store {
      id
      name
    }
    name
    pickup_slots {
      id
      name
      start
      end
      products {
        id
        name
      }
    }
    created_at
    compartments {
      compartment_id
      product {
        id
        name
      }
      quantity
      preordered {
        order_id
        quantity
        pickup_time
        state
        type
      }
    }
  }
`;

export const partnerSelfSignupConfigFragment = gql`
  fragment PartnerSelfSignupConfigFragment on PartnerSelfSignupConfig {
    id
    signup_code
    company_name
    onboarding_fee_cent
    type
    products_transactions {
      article_number
      name
      gtin
      price_cent
    }
    products_purchase {
      article_number
      name
      gtin
      price_cent
    }
    products_rental {
      name
      price_cent
    }
    cancelation_terms
    products_onboarding {
      article_number
      name
      gtin
      count
    }
    billing_address {
      zipcode
      country
      state
      city
      street
      cost_center
      poi_box
      invoice_email
    }
  }
`;

export const basketFragment = gql`
  fragment BasketFragment on Basket {
    id
    user_id
    store_id
    total
    item_total
    state
    order_id
    platform_fee
    campaign {
      ...CampaignFragment
    }
    no_fee_campaign {
      ...CampaignFragment
    }
    items {
      id
      product_id
      name
      price
      image
      quantity
      teaser_text
      comment
      variant_id
      is_promo
      extras {
        extra_id
        name
        price
      }
    }
  }
  ${campaignFragment}
`;

export const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData: {
    __schema: {
      types: [
        {
          kind: 'INTERFACE',
          name: 'ProductInterface',
          possibleTypes: [{ name: 'Product' }, { name: 'FeaturedProduct2' }],
        },
      ],
    },
  },
});
